module.exports = __webpack_public_path__ + "static/media/A1-32-Deskderb-cod140-B.f54261f8.png";